import * as React from 'react'
import { ReactElement } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { IBackgroundLocationState } from '../../../config/appConfig'
import TimeSuggestionDialog, { TrackTimeSuggestionDto } from './TimeSuggestionDialog'
import { useBoolean } from '@fluentui/react-hooks'

export default function TrackTimeDialog(): ReactElement {
    const location = useLocation<IBackgroundLocationState<TrackTimeSuggestionDto>>()
    const history = useHistory<IBackgroundLocationState>()
    const [hideDialog, { setTrue: setHideDialog }] = useBoolean(false)
    const setHideDialogAndReturn = () => {
        setHideDialog()
        history.push(location.state?.background?.pathname || '/')
    }

    return (
        <TimeSuggestionDialog
            hidden={hideDialog}
            setHidden={setHideDialogAndReturn}
            initialValues={location.state?.data}
            onDismiss={setHideDialogAndReturn}
        />
    )
}
